import { createContext } from 'preact';

export type LayerPriority = 'normal' | 'top';

export type LayerContextProps = {
  priority?: LayerPriority;
  getHost?: (priority?: LayerPriority) => Element;
};

export const LayerContext = createContext<LayerContextProps>({});
